import {  makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    box:{
        height:'200px',
        width:'200px',
        borderRadius: '15px',
        position: 'relative',
        marginBottom:'10px'
    },
    profile:{
        height:'100px',
        width:'100px',
        marginLeft:'45px',
        marginTop:'6px'
    },
    T:{
        color:'red',
        marginLeft:'50px'
    },
    T2:{
        color:'blue',
        fontSize:'12px',
        marginLeft:'30px'
    },
   side:{
    [theme.breakpoints.down('xs')]:{
        side:{ display:"none"}
     }
   },
   head:{
    textAlign:'center',
    fontSize:'30px',
    fontFamily:'bold',
    [theme.breakpoints.down('xs')]:{
         display:"none"
     }
   }


}))
export default useStyles;